import { scrollTo } from 'JBPlugin/scroll-to';

(function($){
	let target;
	setTimeout(function() {
		if (location.hash) {
			// we need to scroll to the top of the window first, because the browser will always jump to the anchor first before JavaScript is ready
			window.scrollTo(0, 0);
			target = location.hash.split('#');
			scrollTo('#' + target[1]);
		}
	}, 1);
})(jQuery);
